import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=55bfe0d8&"
import script from "./ProjectDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55bfe0d8')) {
      api.createRecord('55bfe0d8', component.options)
    } else {
      api.reload('55bfe0d8', component.options)
    }
    module.hot.accept("./ProjectDetails.vue?vue&type=template&id=55bfe0d8&", function () {
      api.rerender('55bfe0d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ProjectDetails.vue"
export default component.exports